import { h, render, Component } from 'preact';
import CommonBlock from '../commonBlock';
import Utils from "../../../utils";
import './index.scss';

export default class ScrollingInlineDiv extends CommonBlock {
  constructor(props) {
    super(props);

    const formattedMessages = this.formatMessages(Utils.getCampaignData(this.props.messages, ''));

    this.state = {
      content: '',
      messages: formattedMessages,
      sliderDelay: Utils.getCampaignData(this.props.sliderDelay, 3000),
      direction: Utils.getCampaignData(this.props.sliderDirection, 'forward'),
    };
  }

  componentDidMount() {
    super.componentDidMount();

    if (!this.state.messages?.length)
      return;

      if (this.state.direction === 'backward') {
        const slideContainerEl = document.querySelector('#wioScrollingInlineDiv');
        const slideEl = document.querySelector('.wioScrollingInlineDivContent');
        slideContainerEl.scrollLeft = slideContainerEl.scrollWidth - slideEl.offsetWidth;
      }
      this.autoplayCarousel();
  }

  componentWillUnmount() {
    super.componentWillUnmount();

    const slideContainerEl = document.querySelector("#wioScrollingInlineDiv");
    const slideEl = document.querySelector(".wioScrollingInlineDivContent");
    slideContainerEl.removeEventListener("mouseenter", () => clearInterval(autoplay));

    window.removeEventListener('resize', () => {
        slideWidth = slideEl.offsetWidth;
    });
  }

  formatMessages = (str) => {
    return str
      .replace(/^<p>/, '')
      .replace(/<\/p>$/, '')
      .split(' &amp;&amp;&amp;&amp; ');
  }

  autoplayCarousel() {
    const slideContainerEl = document.querySelector('#wioScrollingInlineDiv');
    const slideEl = document.querySelector('.wioScrollingInlineDivContent');
    let slideWidth = slideEl.offsetWidth;

    // Add resize handler
    window.addEventListener('resize', () => {
      slideWidth = slideEl.offsetWidth;
    });

    // Autoplay
    this.autoplayInterval = setInterval(() => this.navigate(this.state.direction), this.state.sliderDelay);
    slideContainerEl.addEventListener('mouseenter', () => clearInterval(this.autoplayInterval));
    slideContainerEl.addEventListener('mouseleave', () => {
      this.autoplayInterval = setInterval(() => this.navigate(this.state.direction), this.state.sliderDelay);
    });
  }

  navigate(arg) {
    const slideContainerEl = document.querySelector('#wioScrollingInlineDiv');
    const slideWidth = slideContainerEl.offsetWidth;

    if (arg === 'forward') {
      const prevSlide = slideContainerEl.querySelector('.wioScrollingInlineDivContent');
      slideContainerEl.appendChild(prevSlide);
      slideContainerEl.scrollLeft += slideWidth;
    } else if (arg === 'backward') {
      const lastChild = slideContainerEl.querySelector('.wioScrollingInlineDivContent:last-child');
      slideContainerEl.prepend(lastChild);
      slideContainerEl.scrollLeft -= slideWidth;
    }
  }

  render() {
    return (
      <div id="wioScrollingInlineDiv">
        {this.state.messages.map((message, i) => (
          this.renderMessage(message)
        ))}
      </div>
    );
  }

  renderMessage = (message, className) => {
    const contentWithMessage = this.state?.content
      ? this.state.content.replace('{{content}}', message)
      : '';

    return (
      <div
        className={`wioScrollingInlineDivContent ${className ?? ''}`}
        dangerouslySetInnerHTML={{ __html: contentWithMessage }}
      />
    );
  }
}
